export default __webpack_public_path__ + "static/media/logo-black.f6feb8a6.png";